import React from 'react';
import styled from 'styled-components';
import { AdUnitLoadingUI } from '../common/adUnitLoadingUI';

import { numberOfHourlyCardLoading } from '../common/placeholderUtils';
import { DayTitleSectionLoadingUI } from './dayTitleSectionLoadingUI';
import { WeatherInfoLoadingUI } from './weatherInfoLoadingUI';

export const MobileHourCardListItemsLoadingUI = () => {
    return (
        <Container>
            <DayTitleSectionLoadingUI />
            {
                numberOfHourlyCardLoading?.map(hourCardNumber => {
                    return <WeatherInfoLoadingUI key={`mobile-hour-card-weather-info-animated-loading-ui#${hourCardNumber}`} />;
                })
            }
            <AdUnitLoadingUI />
        </Container>
    );
};

const Container = styled.ul`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    list-style-type: none;
    padding: 0;
    height: auto;
`;

